import { Directive, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import {
  Feature,
  OtherRoomCommands,
  OtherRoomProperties,
  RoomCommands,
  RoomProperties,
} from '@vi-iot/client';

import { SrcManagerModalComponent } from '../src-manager-modal/src-manager-modal.component';

@Directive({
  selector: '[appSrcModalManager]',
})
export class SrcModalManagerDirective {
  constructor(private dialog: MatDialog) {}

  @Input('appSrcModalManager') manager: string;

  @Input() room: Feature<RoomProperties | OtherRoomProperties, RoomCommands | OtherRoomCommands>;

  @HostListener('click')
  openManagerDialog(): void {
    this.dialog.open(SrcManagerModalComponent, {
      width: '880px',
      panelClass: 'app-src-manager-dialog',
      data: {
        manager: this.manager,
        room: this.room,
      },
      disableClose: false,
    });
  }
}
